import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { BaseBadgeContainer } from '../BaseBadge/styled';

const TopSecretHotelsStyled = styled(BaseBadgeContainer)`
  background-color: ${({ theme }) => theme.kallisto.color.common.special.topSecretHotels[900]};
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
`;

const TopSecretHotelsBadge = () => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  return (
    <TopSecretHotelsStyled
      $icon={`${localization.imageBasePath}icons/tsh_card.svg`}
      dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.tsh_label_html') }}
    />
  );
};

export default TopSecretHotelsBadge;
